import React from 'react';
import PropTypes from 'prop-types';
import { ComboboxOption } from '@headlessui/react';
import { useFontLoader } from '@dashboard/hooks/useFontLoader';

const propTypes = {
  font: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

const FontOption = ({ font }) => {
  const isDefault = !font._id || font._id === 'default';

  const { isLoaded, isLoading, isFailed } = useFontLoader(
    isDefault ? null : font.name,
    !isDefault, // Only load non-default fonts
  );

  const getFontStyle = () => {
    if (isDefault) {
      return { fontFamily: 'inherit' };
    }

    if (isLoaded) {
      return { fontFamily: `"${font.name}", sans-serif` };
    }

    // Fallback while loading or if failed
    return { fontFamily: 'sans-serif' };
  };

  const getDisplayText = () => {
    if (isDefault) {
      return font.name;
    }

    if (isLoading) {
      return `${font.name}...`;
    }

    if (isFailed) {
      return `${font.name} (failed to load)`;
    }

    return font.name;
  };

  return (
    <ComboboxOption
      key={font._id}
      value={font._id}
      className="cursor-pointer select-none py-2 px-3 w-full text-sm outline-hidden hover:bg-accent hover:text-accent-foreground data-[focus]:bg-accent data-[focus]:text-accent-foreground"
    >
      <span className="block truncate" style={getFontStyle()}>
        {font.name}
      </span>
    </ComboboxOption>
  );
};

FontOption.propTypes = propTypes;

export default FontOption;
